import { render, staticRenderFns } from "./Cardapio.vue?vue&type=template&id=c1ad5358&scoped=true"
import script from "./Cardapio.vue?vue&type=script&lang=js"
export * from "./Cardapio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ad5358",
  null
  
)

export default component.exports